// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-N0l","newExpiryDate":"styles_newExpiryDate__2JVyj","footer":"styles_footer__1N7J7"};